import { gql } from "lib/apolloClient";

export const workbookTemplateFragment = {
  workbookTemplateResourceBasicDetailsItem: gql`
    fragment workbookTemplateResourceBasicDetailsItem on WorkbookTemplateResource {
      id
      label
      type
      resourceType
      state
      attachment {
        ...attachmentFragment
      }
      childrenV2(
        first: $first
        after: $after
        filters: {
          types: $types
          searchText: $searchText
          states: $states
          status: $status
          courseIds: $courseIds
          createdBy: $createdBy
        }
      ) {
        resourceTypeBasedCount {
          totalCount
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            ... on WorkbookTemplateResource {
              id
              label
              type
              resourceType
              status
              state
              attachment {
                ...attachmentFragment
              }
              createdBy {
                id
                firstName
                middleName
                lastName
              }
            }
          }
        }
      }
    }
  `,
  attachmentFragment: gql`
    fragment attachmentFragment on Attachment {
      id
      type
      url
      signedUrl
      name
      thumbUrl
      metadata
    }
  `,
};
